import { Tooltip } from 'antd'
import { Icon } from '@iconify/react'
import type { FC } from 'react'
import classNames from 'classnames'
import styles from './ehrsync.module.scss'

type Props = {
  className?: string
  showIcon?: boolean
  id?: string
  hideTooltip?: boolean
  tooltip?: string
}

export const EhrSyncIcon: FC<Props> = (props) => {
  if (!props.showIcon) return null

  const iconElement = (
    <Icon
      id={props.id}
      width={16}
      height={16}
      icon='mdi:sync-alert'
      style={{ color: 'var(--warning)' }}
      className={classNames(styles.container, props.className)}
    />
  )

  if (props.hideTooltip) {
    return iconElement
  }

  return (
    <Tooltip
      title={props.tooltip ?? 'Appointment not synced with EHR'}
      placement='topLeft'
      align={{ offset: [-12, 4], targetOffset: [0, 10] }}>
      {iconElement}
    </Tooltip>
  )
}
